__turbopack_context__.v({
  "grid": "PromoTiles-module-scss-module__QHv6Ma__grid",
  "heading": "PromoTiles-module-scss-module__QHv6Ma__heading",
  "inner": "PromoTiles-module-scss-module__QHv6Ma__inner",
  "root": "PromoTiles-module-scss-module__QHv6Ma__root",
  "tile": "PromoTiles-module-scss-module__QHv6Ma__tile",
});
